import { IntegrationType } from "../../components/integrations-create/components/common/integration-type/IntegrationTypeCard";

export const integrationTypes: IntegrationType[] = [
  "slack",
  "email",
  "webhook",
  "jira",
];
